/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBackgroundColor = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M2 2h20v20H2zm6.293 16.438.958-2.806h5.064l.958 2.806h2.378L12.861 6h-2.105L6 18.438zm5.406-4.62H9.867l1.899-5.628z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgBackgroundColor as BackgroundColor };
